import React, { FunctionComponent } from "react";
import styled from "styled-components";

export interface IButtonProps {
  disabled?: boolean;
  title: string;
  menu?: boolean;
  color?: string;
  bgColor?: string;
  icon?: JSX.Element;
  iconRight?: JSX.Element;
  hideTitle?: boolean;
  id?: string;
  width?: string;
  flex?: number;
  style?: any;
  clickCallback?: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => void;
}

const ButtonStyles = styled("button")`
  line-height: 1.499;
  position: relative;
  display: inline-block;
  font-weight: 400;
  white-space: nowrap;
  text-align: center;
  border: 1px solid #d9d9d9;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  user-select: none;
  touch-action: manipulation;
  align-items: center;
  height: 32px;
  padding: 0 15px;
  font-size: 14px;
  border-radius: 4px;
  background-color: ${(props: IButtonProps) =>
        props.bgColor ? props.bgColor : "white"};
  color: ${(props: IButtonProps) =>
        props.color ? props.color : "rgba(0, 0, 0, 0.65)"};
  margin: 10px 0;
  > svg {
    margin-right: ${(props: IButtonProps) => (props.hideTitle ? "0" : "6px")};
  }

  &:disabled {
    background: #dcddde;
    color: #84868a;
    opacity: 0.4;
    cursor: not-allowed;
  }

  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {
    animation-name: none !important;
  }
`;

export const Button: FunctionComponent<IButtonProps> = (
    props: IButtonProps
) => {
    const { ...theRest } = props;
    return (
        <ButtonStyles
            {...theRest}
            onClick={(event) => (props.disabled ? null : props.clickCallback(event))}
            id={props.id}
        >
            {props.icon}
            {props.hideTitle ? null : props.title}
            {props.iconRight ? props.iconRight : null}
        </ButtonStyles>
    );
};
